interface IConfig {
  [key:string]: {
    production: boolean;
    apiURL: string;
    quizURL: string;
    shareURL: string;
    ipInfoUrl: string;
  }
}

const config:IConfig = {
  'development': {
    production: false,
    apiURL: 'http://api.quizwizards.test/api',
    quizURL: 'http://app.quizwizards.test',
    shareURL: 'http://api.quizwizards.test/share',
    ipInfoUrl: 'https://ipinfo.io/json'
  },
  'staging': {
    production: false,
    apiURL: 'https://api-staging.quizwizards.com/api',
    quizURL: 'https://app-staging.quizwizards.com',
    shareURL: 'https://api-staging.quizwizards.com/share',
    ipInfoUrl: 'https://ipinfo.io/json'
  },
  'production': {
    production: true,
    apiURL: 'https://api.quizwizards.com/api',
    quizURL: 'https://app.quizwizards.com',
    shareURL: 'https://api.quizwizards.com/share',
    ipInfoUrl: 'https://ipinfo.io/json'
  }
}

const stage:string = process.env.REACT_APP_STAGE || 'development';

export default config[stage];